/**
 * Created by mac on 12/23/20
 */

const Collectible = function (unit) {
    UnitComponent.call(this, unit);

    const data = this.unit.getData();

    if (data.feedableTarget) {
        this.feedables = [];
    }
};

Collectible.prototype = Object.create(UnitComponent.prototype);
Collectible.prototype.constructor = Collectible;

Collectible.prototype.onCollection = function (index, callback) {
    callback = callback || function () {};
    if (this.view) {
        this.view.collectionAnimation(index, callback);
    } else {
        callback();
    }
};

Collectible.prototype.onFeed = function (target, callback) {
    Map2d.currentMap.showLayerTile(Map2d.LAYER_UNITS, this.unit.x, this.unit.y);

    if (this.view) {
        this.view.feedAnimation(target, callback);
    } else if (callback) {
        callback();
    }
};

Collectible.prototype.isMovable = function () {
    const type = this.unit.getType();

    if (type === "fruit" && this.unit.isBuilt()) {
        return false;
    }

    return true;
};

Collectible.prototype.needCollectConfirmation = function () {
    const lastStage = Families[this.unit.code].units.length - 1;

    if (this.unit.code === "energy") {
        return this.unit.stage !== lastStage;
    }

    return !cleverapps.gameModes.silentInfoView && this.unit.getType() === "valuables" && this.unit.stage >= 2 && this.unit.stage !== lastStage;
};

Collectible.prototype.getActionInfo = function () {
    if (this.needCollectConfirmation()) {
        return {
            buttons: {
                valuable: {
                    action: this.collect.bind(this),
                    unit: this.unit
                }
            },
            title: Messages.get("Collect")
        };
    }
};

Collectible.prototype.setFeedables = function (feedables) {
    this.feedables = feedables;
};

Collectible.prototype.canRemoved = function () {
    return this.feedables && this.feedables.length === 0;
};

Collectible.prototype.findFeadableTarget = function () {
    let targetUnit = undefined;
    let minDistance = Number.MAX_VALUE;
    const feedables = this.feedables;
    for (let i = 0; i < feedables.length; i++) {
        const feedable = feedables[i];
        if (Map2d.currentMap.getUnit(feedable.unit.x, feedable.unit.y) === feedable.unit && feedable.canCollect(this.unit)) {
            const distance = cc.pDistance(feedable.unit, this.unit);
            if (distance < minDistance) {
                minDistance = distance;
                targetUnit = feedable.unit;
            }
        }
    }

    return targetUnit;
};

Collectible.prototype.handleClick = function () {
    if (this.tryCollect()) {
        cleverapps.effects.fire("ui.button.click");
        return true;
    }
};

Collectible.prototype.tryCollect = function () {
    const data = this.unit.getData();

    if (this.unit.isUnmergeable() && !data.feedableTarget) {
        this.collect();
        return true;
    }

    if (data.feedableTarget) {
        const targetUnit = this.findFeadableTarget();

        if (targetUnit) {
            this.collect(targetUnit);
            return true;
        }
        cleverapps.centerHint.createTextHint(Messages.get("CenterHint.noOneToFeed"));
        return false;
    }

    if (this.needCollectConfirmation()) {
        return false;
    }

    if (data.collectible.harvested) {
        const capacity = Map2dLocation.currentLocation.harvested.getCapacity();
        const amount = Map2dLocation.currentLocation.harvested.getItemsAmount();

        if (capacity - amount < this.getValue()) {
            Map2dLocation.currentLocation.harvested.needsToShowTip();
            return false;
        }
    }

    this.collect();
    return true;
};

Collectible.prototype.collect = function (target, index) {
    if (this.collected) {
        return;
    }

    if (this.unit.getType() === "fruit") {
        const x = this.unit.x;
        const y = this.unit.y;

        Map2dLocation.currentLocation.setTimeout(() => {
            [
                { x: 1, y: 0 },
                { x: -1, y: 0 },
                { x: 0, y: 1 },
                { x: 0, y: -1 }
            ].forEach(function (dir) {
                const unit = Map2d.currentMap.getUnit(x + dir.x, y + dir.y);

                if (unit && unit.code === this.unit.code && unit.stage === this.unit.stage && !unit.points) {
                    unit.findComponent(Collectible).collect();
                }
            }, this);
        }, 100);
    }

    this.collected = true;

    if (this.unit.findComponent(Pulsing)) {
        this.unit.findComponent(Pulsing).setRemoved(true);
    }

    if (Map2d.currentMap.advice) {
        Map2d.currentMap.advice.boo();
    }

    if (this.unit.getData().feedableTarget && target && target.isFeedable()) {
        const feedable = target.findComponent(Feedable);
        feedable.feed();
        Map2d.currentMap.showLayerTile(Map2d.LAYER_UNITS, target.x, target.y);
        this.onFeed(target.onGetView(), () => {
            feedable.onFeed();
        });
    } else if (this.unit.getData().collectible.harvested) {
        this.onCollection(index, Map2dLocation.currentLocation.harvested.onChange.bind(Map2dLocation.currentLocation.harvested));
        Map2dLocation.currentLocation.harvested.add(this.unit.code, this.getValue(), true);
    } else {
        let rewardType = this.unit.getData().collectible.rewardType || this.unit.code;
        if (rewardType === "coins") {
            rewardType = "soft";
        } else if (rewardType === "rubies") {
            rewardType = "hard";
        }

        const rewardTypes = ["wands", "soft", "hard", "energy"];

        if (rewardTypes.includes(rewardType)) {
            this.unit.onDestruction();
        }

        const event = cleverapps.EVENTS.EARN.FIELD;
        const reward = new Reward(rewardType, this.getValue(), { event });
        reward.receiveReward();

        const flyingAnimation = rewardTypes.includes(rewardType) ? Reward.JUMP_COLLECT_ANIMATION : Reward.COLLECT_ANIMATION;

        reward.collectRewardsAnimation(this.unit, {
            flyingAnimation,
            deltaSource: this.unit.onGetView(),
            path: true,
            showSparks: true,
            beginScale: 1
        });
    }

    this.unit.remove(true);

    Map2dLocation.currentLocation.setTimeout(() => {
        const data = { affected: this.unit };
        Map2d.mapEvent(Map2d.HARVEST, data);
        cleverapps.tutorial.trigger(Map2d.HARVEST, data);
    }, 0);
};

Collectible.prototype.getValue = function () {
    return this.unit.getData().value;
};
